import { mapState } from "vuex";
import { Globals } from "../../../global_constants/constants";

export default {
  computed: {},
  methods: {
    FilterUsersByEmail(email) {
      const filteredUsers = Globals.owners_emails;
      let conectedUserEmail = email;
      let approvedUser;
      filteredUsers.filter(e => {
        if (e === conectedUserEmail) {
          approvedUser = e;
        }
      });
      return approvedUser;
    }
  }
};
